export { default } from './GoalNavDucks'
export * from './GoalNavDucks'
